<template lang="pug">
  .comments__block
    .comments__container
      .comment__container(v-for="comment in list")
        .comment__text {{ comment.text }}
        .comment__details
          .val {{ `Добавлено ${comment.created}` }}
          .val {{ `Пользователем ${comment.added_by}` }}
        el-button(size="mini" type="danger" @click="startDeleteOrderComment(comment.id)") Удалить
    .new-comment__container
      el-input(v-model="newCommentText")
      el-button(type="primary" :disabled="!newCommentText" @click="startAddOrderComment") Добавить
</template>

<script>
import { mapActions } from 'vuex';
import { ADD_ORDER_COMMENT, DELETE_ORDER_COMMENT } from "../../store/const/orders";
import instruments from "../../mixins/instruments";

export default {
  name: 'Comments',
  props: {
    orderId: { type: String, default: () => '' },
    list: { type: Array, default: () => [] },
  },
  mixins: [
    instruments,
  ],
  data() {
    return {
      newCommentText: '',
    }
  },
  methods: {
    ...mapActions('orders', {
      addNewComment: ADD_ORDER_COMMENT,
      deleteComment: DELETE_ORDER_COMMENT,
    }),
    async startAddOrderComment() {
      this.$confirm('Вы действительно хотите добавить комментарий?', 'Подтверждение').then(async () => {
        const request = await this.addNewComment({ id: this.orderId, text: this.newCommentText });
        this.handleRequestAndNotify({
          request,
          successMessage: 'Комментарий успешно добавлен',
          errorMessage: 'Ошибка добавления комментария',
          successMethod: this.startResetOrderComment,
        });
      }).catch(() => {
        this.$message.info('Отменено')
      });
    },
    async startDeleteOrderComment(comment_id) {
      this.$confirm('Вы действительно хотите удалить комментарий?', 'Подтверждение').then(async () => {
        const request = await this.deleteComment({ comment_id });
        this.handleRequestAndNotify({
          request,
          successMessage: 'Комментарий успешно удален',
          errorMessage: 'Ошибка удаления комментария',
        });
      }).catch(() => {
        this.$message.info('Отменено')
      });
    },
    startResetOrderComment() {
      this.newCommentText = '';
    }
  }
};
</script>
<style scoped>
.comments__container {
  display: flex;
  flex-wrap: wrap;
  height: 420px;
  overflow-y: scroll;
  border: 1px solid #d3d3d3;
}

.comment__container {
  width: 420px;
  height: 160px;
  padding: 4px;
  margin: 4px;
  border: 1px solid #afafaf;
  overflow-y: scroll;
}

.comment__text {
  padding: 8px;
  margin: 4px;
  word-wrap: break-word;
  border-radius: 4px;
  background-color: #e5e5e5;
  border: 1px solid #d3d3d3;
}

.comment__details {
  margin-top: 8px;
  font-size: 12px;
  font-weight: bold;
  font-style: italic;
}

.new-comment__container {
  margin-top: 8px;
  padding: 8px;
  border: 1px solid #d3d3d3;
}
</style>
